import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router';
import { useSettingsSelector } from 'src/client/redux';

export const useSettingsNavigation = () => {
  const location = useLocation<{ canGoBack?: boolean }>();
  const history = useHistory();
  const homepage = useSettingsSelector('homepage');
  const isSettings = location.pathname.startsWith('/settings');

  const handleSettingsClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      if (!isSettings) return;

      e.preventDefault();

      if (location?.state?.canGoBack) {
        return history.goBack();
      }

      return history.replace(`/${homepage}`);
    },
    [history, homepage, isSettings, location],
  );

  return {
    handleSettingsClick,
  };
};
